import React, { useContext } from 'react';

import Badge from '../Badge';
import { ContentContext } from 'Components/hooks/context';
import GlobalLink from './../GlobalLink';
import GlobalReferral from './GlobalReferral';
import { component } from './styles.module.scss';
import useWindowDimensions from 'Components/hooks/useWindowDimensions';

const Header = ({ global = false }) => {
  const { width } = useWindowDimensions();
  const content = useContext(ContentContext);

  return width > 450 ? (
    <nav className={`nav background-dark ${component}`}>
      <div className='logo-container'>
        <a>
          <figure className='navbar-brand'>
            <Badge />
          </figure>
        </a>
      </div>
      <div className='title-container'>
        {!global && (
          <GlobalReferral />
        )}
      </div>
    </nav>
  ) : (
    <nav className={`nav background-dark ${component}`}>
      <div className='logo-container'>
        <GlobalLink>
          <figure className='navbar-brand'>
            <Badge />
          </figure>
          <span className='mobile-title'>
            {content.common.nav.title}
          </span>
        </GlobalLink>
      </div>
    </nav>
  );
};

export default Header;
